module.exports = "/_next/static/images/f6afe897894e378f2a0abe93af41e513-roxinho-single-md@1x.jpg.webp";